import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {createCategory} from '../../../modules/admin/docs';
import processName from '../../../utils/processName';
import validateText from '../../../utils/validateText';
import styles from './styles/create-modal.module.css';

import ButtonBox from '../ButtonBox';
import ErrorBtnBox from '../../common-women/ErrorBtnBox';
import InfoBox from '../../common-women/InfoBox';
import InputExpand from '../../common-women/InputExpand';

export default function CreateModal({ handleClose, reReadDocsList }) {
    const dispatch = useDispatch();

    const { currentId, createResponse, createError, createLoading } = useSelector(({ docs, loading }) => ({
        currentId: docs.currentId,
        createResponse: docs.createResponse,
        createError: docs.createError,
        createLoading: loading['docs/CREATE_CATEGORY']
    }));

    const initialCreateField = {
        name: '',
        description: '',
        nameError: false,
        descriptionError: false
    };

    const [createField, setCreateField] = useState(initialCreateField);

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        const validationOptions = {
            name: {
                minLength: 2,
                maxLength: 50,
                specialChars: true,
                continuousChars: true,
                emptyText: true,
                ignoreExtension: true
            },
            description: {
                minLength: 0,
                maxLength: 100,
                specialChars: false,
                continuousChars: false,
                emptyText: false,
                ignoreExtension: false
            }
        };

        const validation = validateText(value, validationOptions[name]);

        setCreateField({
            ...createField,
            [name]: value,
            [`${name}Error`]: !validation.isValid
        });
    };

    const validateCreateBtn = () => {
        const { name, nameError, descriptionError } = createField;

        return name.trim() !== '' && !nameError && !descriptionError;
    };

    const handleCreate = () => {
        const { name, description } = createField;

        dispatch(createCategory({ name, description, currentId }));
    };

    const handleCloseModal = () => {
        setCreateField(initialCreateField);
        handleClose();
    };

    useEffect(() => {
        if (!createLoading && createResponse) {
            handleCloseModal();
            reReadDocsList();
        }

        if (!createLoading && createError && createError.code === 400) {
            setCreateField({
                ...createField,
                nameError: true
            });
        }
    }, [createLoading, createResponse, createError]);
    
    return (
        <div className={styles.wrapper}>
            <p className={styles.title}>카테고리 추가</p>
            <div className={styles.boxFirst}>
                <InputExpand
                    type='category-name'
                    label='이름'
                    maxLength='50'
                    placeholder='이름을 입력해 주세요'
                    name='name'
                    value={createField.name}
                    displayValue={processName(createField.name)} // 글자수 표시용 값
                    error={createField.nameError}
                    handleChange={handleChange}
                />
                <InfoBox type='CATEGORY' width='100%' />
            </div>
            <InputExpand
                type='category-description'
                label='설명'
                maxLength='100'
                placeholder='설명을 입력해 주세요'
                name='description'
                value={createField.description}
                error={createField.descriptionError}
                handleChange={handleChange}
            />
            <ErrorBtnBox
                fileType='category'
                requestType='create'
                error={createError}
            >
                <ButtonBox
                    text='추가'
                    inactiveColor='#CFCED4'
                    activeColor='#825DFC'
                    validateBtn={validateCreateBtn}
                    handleCancle={handleCloseModal}
                    handleClick={handleCreate}
                    loading={createLoading}
                />
            </ErrorBtnBox>
        </div>
    );
}
